@if ((isLoading$ | async) === true) {
	<uc-university-skeleton [header]="false" [banner]="true" />
}
@if (university$ | async; as university) {
	<main
		class="relative sm:mt-0"
		ucUniProfileGAEvent
		ucUniImpression
		[eventTypes]="['view']"
		[uniId]="university.id"
		[uniName]="university.name"
		[ugSearchOrderPosition]="null"
		[cleSearchOrderPosition]="null"
		product="postgraduate"
		degreeLevel="Postgraduate"
		profileTab="Postgraduate"
		[regionFilter]="university.address.region"
	>
		@if ((isLoading$ | async) === false) {
			<uc-university-slider
				[uniGallery]="uniGallery"
				[product]="product"
				[isFeaturedGallery]="isFeaturedGallery"
				[uniSliderCopy]="
					isFeaturedPostgraduate
						? uniSliderCopy.postgraduate
						: uniSliderCopy.nonClient
				"
				[id]="university.id"
				[saved]="university.saved"
				[delta]="1"
				[uniName]="university.name"
				[ugSearchOrderPosition]="null"
				[cleSearchOrderPosition]="null"
			>
				<uc-university-header-title
					headerTitle
					[name]="university.name"
					[recommendedPercentage]="university.stats.recommended_percentage"
					[paidFeatures]="university.paid_features"
					[subdirectory]="product"
					[product]="product"
					[slug]="university.slug"
					[uniId]="university.id"
				/>
				<uc-cta-non-clearing
					[isFeatured]="isFeaturedPostgraduate"
					[uniId]="university.id"
					[externalUrl]="university.postgraduate.external_url"
					[externalEventsUrl]="university.postgraduate.external_events_url"
					[externalProspectusUrl]="
						university.postgraduate.external_prospectus_url ?? ''
					"
					[product]="product"
					[uniSlug]="university.slug"
					[uniName]="university.name"
					sourceType="uni"
					[privacyPolicyUrl]="university.privacy_policy_url"
					[ugSearchOrderPosition]="null"
				/>
			</uc-university-slider>
			<div class="container sm:border-t">
				@if (isFeaturedPostgraduate) {
					<div class="pt-8 border-t sm:divider sm:border-t-0">
						<uc-university-information
							[totalStudents]="university.stats.total_students"
							[studentsInHalls]="university.stats.students_in_hall"
							[fullTime]="university.stats.full_time_students_percentage"
							[avgTariffPoints]="university.stats.average_entry_tariff"
						/>
					</div>
				}
				@if (university.overview) {
					<div
						class="flex flex-col gap-4 divider"
						[ngClass]="{ 'border-t sm:border-t-0': !isFeaturedPostgraduate }"
					>
						<uc-heading
							headingTitle="About {{ university.name }}"
							[description]="university.overview"
						/>
						@if (isFeaturedPostgraduate) {
							<uc-visit-website-btn
								[externalUrl]="university.postgraduate.external_url"
								[source]="university.name"
								[uniId]="university.id"
								sourceType="uni"
								product="postgraduate"
								customStyles="w-full sm:max-w-xs"
								componentName="University Overview"
								[uniName]="university.name"
								[ugSearchOrderPosition]="null"
							/>
						}
					</div>
				}
			</div>
			<!-- show for featured postgraduate unis only -->
			@if (isFeaturedPostgraduate) {
				<div>
					<uc-campus-locations
						[uniId]="university.id"
						[uniName]="university.name"
					/>
					<!-- postgraduate events -->
					@if (events$ | async; as events) {
						<uc-university-events
							[paidFeatures]="university.paid_features"
							[rating]="university.stats.rating"
							[events]="events"
							[uniName]="university.name"
							[uniSlug]="university.slug"
							[uniLogo]="university.logo"
							[product]="product"
							[uniId]="university.id"
							[externalEventsUrl]="
								university.postgraduate.external_events_url
							"
							[ugSearchOrderPosition]="null"
							[privacyPolicyUrl]="university.privacy_policy_url"
						/>
					}
					<uc-course-search-banner
						[product]="product"
						[uniName]="university.name"
						[uniSlug]="university.slug"
						description="Take the next steps at {{
							university.name
						}} with our postgraduate course search."
					/>
					<uc-university-sections
						[universityUrl]="universityUrl"
						[uniId]="university.id"
						[product]="product"
						[uniName]="university.name"
						[externalUrl]="university.postgraduate.external_url"
						[ugSearchOrderPosition]="null"
					/>
					<ng-template #universitySectionsLoading>
						<uc-university-skeleton [header]="false" [banner]="true" />
					</ng-template>
					<uc-university-accommodation
						[universityExternalUrl]="university.postgraduate.external_url"
						[universityUrl]="universityUrl"
						[uniId]="university.id"
						[uniName]="university.name"
						[product]="product"
						[ugSearchOrderPosition]="null"
					/>
				</div>
			}
			@if (!isFeaturedPostgraduate) {
				<div class="container pb-8 lg:pb-0">
					<uc-recommended-unis-grid
						product="postgraduate"
						componentName="PG Recommended Universities"
					/>
				</div>
			}
			<!-- On mobile -> show university buttons at the bottom -->
			@if (university) {
				<uc-client-profile-sticky-lead-bar-mobile
					[isFeatured]="isFeaturedPostgraduate"
				>
					<uc-visit-website-btn
						customStyles="w-full"
						[externalUrl]="university.postgraduate.external_url"
						componentName="Sticky Lead Bar"
						[uniId]="university.id"
						[source]="university.name"
						sourceType="uni"
						[uniName]="university.name"
						[ugSearchOrderPosition]="null"
						product="postgraduate"
					/>
				</uc-client-profile-sticky-lead-bar-mobile>
			}
			<!-- On desktop -> show university buttons at the bottom-->
			@if (isFeaturedPostgraduate) {
				<uc-client-profile-sticky-lead-bar-desktop
					[uniId]="university.id"
					[uniName]="university.name"
					[product]="product"
					[paidFeatures]="university.paid_features"
					[externalUrl]="university.postgraduate.external_url"
					[prospectusExternalUrl]="
						university.postgraduate.external_prospectus_url ?? ''
					"
					[externalEventsUrl]="university.postgraduate.external_events_url"
					[showClearing]="false"
					[source]="university.name"
					sourceType="uni"
					[privacyPolicyUrl]="university.privacy_policy_url"
					[ugSearchOrderPosition]="null"
					[cleSearchOrderPosition]="null"
				/>
			}
		}
	</main>
}
